webpackJsonp([3],{

/***/ 212:
/***/ function(module, exports) {

	module.exports = {
		"data": {
			"site": {
				"siteMetadata": {
					"title": "React Gravatar"
				}
			}
		},
		"pathContext": {
			"component": "/Users/kylemathews/programs/react-gravatar/www/pages/index.js",
			"path": "/"
		}
	};

/***/ }

});


/** WEBPACK FOOTER **
 ** 3.path---index-b52eb9c0.js
 **/